import type { ReactNode } from 'react';
import { Logo } from '@/components/ui/logo';
import { Footer } from '@/components/footer';

interface AuthLayoutProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  wide?: boolean;
}

export function AuthLayout({
  title,
  subtitle,
  children,
  wide = false,
}: AuthLayoutProps) {
  return (
    <div className="h-screen bg-gradient-to-br from-emerald-50 to-blue-50 flex items-start justify-center overflow-y-auto py-8 px-6">
      <div className={`w-full space-y-8 ${wide ? 'max-w-5xl' : 'max-w-md'}`}>
        <div className="text-center space-y-4">
          <Logo size={80} />

          <div>
            {title && (
              <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            )}
            {subtitle && <p className="text-gray-600">{subtitle}</p>}
          </div>
        </div>
        {children}
        <Footer />
      </div>
    </div>
  );
}
